<div class="customModal" *ngIf="showModal">
  <div data-aos="zoom-in" class="content ">
      <h4 class="msg">Are you sure you want to delete this?</h4>
      <div class="buttons">
        <button (click)="ifYes()" class="customBtn hoverable yes">Yes</button>
      <button (click)="ifNo()" class="customBtn hoverable no">No</button>
      </div>
  </div>
</div>
<div class="container">
  <div class="pageTitle text-center my-5">
    <h1>Looking for a loving family</h1>
  <p>Dogs and cats are looking for a warm and loving home. Dreaming of adopting a dog or cat?</p>
  </div>
</div>
<app-search-nsort></app-search-nsort>
<div class="row d-flex justify-content-center p-5">
  <div data-aos="zoom-out-up" class="card shadow hoverable m-4 " style="width: 18rem;" *ngFor="let dog of dogs_ar">

    <figure  class="hover-img">
      <div [ngStyle]="{'background-image': 'url(' + dog.image || '../../images.noImg.jpg' + ')'}" class="card-img-top ngBackground" alt="..."></div>

      <figcaption >
        <div class="options">
        <h4 *ngIf="isLoggedIn && dog.user_id === userInfo._id" class="edit hover-underline-animation"><a routerLink="/editDog/{{dog._id}}"><i class="fs-3 fa fa-pencil-square-o" aria-hidden="true"></i></a>
          </h4>
        <h4 *ngIf="isLoggedIn && dog.user_id === userInfo._id" class="delete hover-underline-animation"><a (click)="userDeleteRequest(dog._id)"><i class="fs-3 fa fa-trash-o" aria-hidden="true"></i></a>
          </h4>
        <h5 *ngIf="!isLoggedIn" class="notLoggedMsg text-warning">*Please login to Edit/delete*</h5>
        <h5 *ngIf="isLoggedIn && dog.user_id !== userInfo._id" class="notLoggedMsg text-warning">*You can only edit dogs you've added!*</h5>
        </div>
      </figcaption>
    </figure>

    <div class="card-body">
      <h5 class="card-title text-center">{{dog.name}}</h5>
      <p class="card-text text-center">{{dog.description.substr(0,100)}}...</p>
      <div class="d-flex justify-content-evenly">
        <span class="badge bg-warning text-dark customBadge"><i class="fa fa-birthday-cake" aria-hidden="true"></i>
          {{dog.age}} y.o</span>
        <span class="badge bg-warning text-dark customBadge"><i class="fa fa-expand" aria-hidden="true"></i>
          {{dog.size}}</span>
          <span class="badge bg-warning text-dark customBadge"><i class="fa fa-mars" aria-hidden="true"></i>
             {{dog.gender}}</span>
      </div>
      <div class="d-flex mt-1 justify-content-evenly">
        <span class="badge bg-warning text-dark customBadge"><i class="fa fa-paw" aria-hidden="true"></i>
          :{{dog.breed}}</span>
      </div>
  
    <div class="d-flex justify-content-center my-3">
      <a href="#" class="btn btn-dark customPetmeBtn">Pet Me <i class="fa fa-heart" aria-hidden="true"></i>
      </a>
    </div>
    </div>
  </div>
</div>


